import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M18.75 0h-18A.75.75 0 0 0 0 .75V13.5A1.5 1.5 0 0 0 1.5 15H18a1.5 1.5 0 0 0 1.5-1.5V.75a.75.75 0 0 0-.75-.75M7.004 7.5 1.5 12.545V2.455zm1.11 1.017 1.125 1.036a.75.75 0 0 0 1.014 0l1.125-1.036 5.438 4.983H2.678zM12.496 7.5 18 2.454v10.092z"
    }, null, -1)
  ]))]))
}
export default { render: render }